import { isPlivoProvider } from "@/src/utils/callsUtils.js";
import { imageNames } from "@/src/constants/imageConstants.js";
import { assignCallTypesList } from "@/src/constants/callConstants.js";
import { telephonyProviders } from "@/src/constants/telephonyConstants.js";
import ContactDetails from "@/src/views/business/ContactDetails.vue";
import BusinessAddress from "@/src/views/business/BusinessAddress.vue";
import BusinessInformation from "@/src/views/business/BusinessInformation.vue";
import SupportingDocuments from "@/src/views/business/SupportingDocuments.vue";

export const assignPhoneNumberTypesList = [
  assignCallTypesList.USER,
  assignCallTypesList.TEAM,
];

export const countryMapping = {
  US: "US",
  UK: "GB",
  NZ: "NZ",
  CH: "CH",
  IN: "IN",
  AU: "AU",
  SG: "SG",
  CA: "CA",
  ES: "ES",
  DE: "DE",
  FR: "FR",
  JP: "JP",
  PT: "PT",
  BR: "BR",
  IE: "IE",
  MY: "MY",
};

export const countryCodeMapping = {
  [countryMapping.US]: "US",
  [countryMapping.UK]: "GB",
  [countryMapping.NZ]: "NZ",
  [countryMapping.CH]: "CH",
  [countryMapping.IN]: "IN",
  [countryMapping.AU]: "AU",
  [countryMapping.SG]: "SG",
  [countryMapping.CA]: "CA",
  [countryMapping.ES]: "ES",
  [countryMapping.DE]: "DE",
  [countryMapping.FR]: "FR",
  [countryMapping.JP]: "JP",
  [countryMapping.PT]: "PT",
  [countryMapping.BR]: "BR",
  [countryMapping.IE]: "IE",
  [countryMapping.MY]: "MY",
};

export const countryFlagMapping = {
  [countryMapping.US]: imageNames.FLAG_US,
  [countryMapping.UK]: imageNames.FLAG_UK,
  [countryMapping.NZ]: imageNames.FLAG_NZ,
  [countryMapping.CH]: imageNames.FLAG_CH,
  [countryMapping.IN]: imageNames.FLAG_IN,
  [countryMapping.AU]: imageNames.FLAG_AU,
  [countryMapping.SG]: imageNames.FLAG_SG,
  [countryMapping.CA]: imageNames.FLAG_CA,
  [countryMapping.ES]: imageNames.FLAG_ES,
  [countryMapping.DE]: imageNames.FLAG_DE,
  [countryMapping.FR]: imageNames.FLAG_FR,
  [countryMapping.JP]: imageNames.FLAG_JP,
  [countryMapping.PT]: imageNames.FLAG_PT,
  [countryMapping.BR]: imageNames.FLAG_BR,
  [countryMapping.IE]: imageNames.FLAG_IE,
  [countryMapping.MY]: imageNames.FLAG_MY,
};

export const countryTelephonyProviderMapping = {
  [countryMapping.US]: telephonyProviders.twilio,
  [countryMapping.CA]: telephonyProviders.twilio,
  [countryMapping.UK]: telephonyProviders.twilio,
  [countryMapping.NZ]: telephonyProviders.twilio,
  [countryMapping.CH]: telephonyProviders.twilio,
  [countryMapping.BR]: telephonyProviders.twilio,
  [countryMapping.IE]: telephonyProviders.twilio,
  [countryMapping.MY]: telephonyProviders.twilio,
  [countryMapping.IN]: telephonyProviders.plivo,
  [countryMapping.AU]: telephonyProviders.plivoInternational,
  [countryMapping.SG]: telephonyProviders.plivoInternational,
};

export const telephonyProviderGenericWrapper = {
  [telephonyProviders.twilio]: telephonyProviders.twilio,
  [telephonyProviders.plivo]: telephonyProviders.plivo,
  [telephonyProviders.plivoInternational]: telephonyProviders.plivo,
};

export const countryDetails = {
  [countryMapping.US]: {
    id: countryMapping.US,
    name: "United States",
    numberCode: "+1",
    countryCode: countryCodeMapping[countryMapping.US],
    flag: countryFlagMapping[countryMapping.US],
  },
  [countryMapping.CA]: {
    id: countryMapping.CA,
    name: "Canada",
    numberCode: "+1",
    countryCode: countryCodeMapping[countryMapping.CA],
    flag: countryFlagMapping[countryMapping.CA],
  },
  [countryMapping.UK]: {
    id: countryMapping.UK,
    name: "United Kingdom",
    numberCode: "+44",
    countryCode: countryCodeMapping[countryMapping.UK],
    flag: countryFlagMapping[countryMapping.UK],
  },
  [countryMapping.NZ]: {
    id: countryMapping.NZ,
    name: "New Zealand",
    numberCode: "+64",
    countryCode: countryCodeMapping[countryMapping.NZ],
    flag: countryFlagMapping[countryMapping.NZ],
  },
  [countryMapping.CH]: {
    id: countryMapping.CH,
    name: "Switzerland",
    numberCode: "+41",
    countryCode: countryCodeMapping[countryMapping.CH],
    flag: countryFlagMapping[countryMapping.CH],
  },
  [countryMapping.IN]: {
    id: countryMapping.IN,
    name: "India",
    numberCode: "+91",
    countryCode: countryCodeMapping[countryMapping.IN],
    flag: countryFlagMapping[countryMapping.IN],
  },
  [countryMapping.AU]: {
    id: countryMapping.AU,
    name: "Australia",
    numberCode: "+61",
    countryCode: countryCodeMapping[countryMapping.AU],
    flag: countryFlagMapping[countryMapping.AU],
  },
  // [countryMapping.BR]: {
  //   id: countryMapping.BR,
  //   name: "Brazil",
  //   numberCode: "+55",
  //   countryCode: countryCodeMapping[countryMapping.BR],
  //   flag: countryFlagMapping[countryMapping.BR],
  // },
  // [countryMapping.IE]: {
  //   id: countryMapping.IE,
  //   name: "Ireland",
  //   numberCode: "+353",
  //   countryCode: countryCodeMapping[countryMapping.IE],
  //   flag: countryFlagMapping[countryMapping.IE],
  // },
  // [countryMapping.SG]: {
  //   id: countryMapping.SG,
  //   name: "Singapore",
  //   numberCode: "+65",
  //   countryCode: countryCodeMapping[countryMapping.SG],
  //   flag: countryFlagMapping[countryMapping.SG],
  // },
};

const countryConfigurations = {
  [countryMapping.US]: {
    requiresAreaCode: true,
    requiresVerification: false,
    autoGenerateNumber: false,
    showRegenerateButton: true,
  },
  [countryMapping.CA]: {
    requiresAreaCode: true,
    requiresVerification: false,
    autoGenerateNumber: false,
    showRegenerateButton: true,
  },
  [countryMapping.IN]: {
    requiresAreaCode: false,
    requiresVerification: false,
    autoGenerateNumber: true,
    showRegenerateButton: true,
  },
  [countryMapping.UK]: {
    requiresAreaCode: false,
    requiresVerification: true,
    autoGenerateNumber: false,
    showRegenerateButton: true,
  },
  [countryMapping.NZ]: {
    requiresAreaCode: false,
    requiresVerification: true,
    autoGenerateNumber: false,
    showRegenerateButton: true,
  },
  [countryMapping.CH]: {
    requiresAreaCode: false,
    requiresVerification: true,
    autoGenerateNumber: false,
    showRegenerateButton: true,
  },
  [countryMapping.AU]: {
    requiresAreaCode: false,
    requiresVerification: false,
    autoGenerateNumber: true,
    showRegenerateButton: true,
  },
};

export const getCountryConfig = (countryCode) => {
  return (
    countryConfigurations[countryCode] ||
    countryConfigurations[countryMapping.US]
  );
};

export const getCountryList = (source = "") => {
  return Object.values(countryDetails).filter((country) => {
    if (source === "business_receptionist") {
      return countryTelephonyProviderMapping[country.id] === telephonyProviders.twilio;
    }

    if (country.id === countryMapping.NZ) {
      return !!localStorage.getItem("new_zealand_numbers");
    }

    if (isPlivoProvider(country.id)) {
      return !!localStorage.getItem("plivo");
    }
    return true;
  });
};

export const countriesThatRequireVerification = [
  countryMapping.UK,
  countryMapping.NZ,
  countryMapping.CH,
];

const commonMessages = {
  failure:
    "There seems to be an issue with your business verification, please check the issues and submit for verification again.",
};

export const verificationStatements = Object.fromEntries(
  countriesThatRequireVerification.map((countryCode) => [
    countryCode,
    {
      text: `Please verify your business in ${countryDetails[countryCode].name} to comply with local regulations for getting phone numbers.`,
      ...commonMessages,
    },
  ]),
);

export const registrationAuthorityOptions = [
  { id: "UK:CRN", text: "UK: Company Registration Number (CRN)" },
  { id: "US:EIN", text: "USA: Employer Identification Number (EIN)" },
  { id: "CA:CBN", text: "Canada: Canadian Business Number (CBN)" },
  { id: "AU:ACN", text: "Australia: Company Number from ASIC (ACN)" },
];

export const registrationSubmissionStatus = {
  BUSINESS_INFORMATION: "BUSINESS_INFORMATION",
  BUSINESS_ADDRESS: "BUSINESS_ADDRESS",
  CONTACT_DETAILS: "CONTACT_DETAILS",
  SUPPORTING_DOCUMENTS: "SUPPORTING_DOCUMENTS",
  SUBMITTED: "SUBMITTED",
  FAILED: "FAILED",
  COMPLETED: "COMPLETED",
};

export const twillioBundleStatus = {
  DRAFT: "draft",
  PENDING_REVIEW: "pending-review",
  IN_REVIEW: "in-review",
  TWILIO_REJECTED: "twilio-rejected",
  TWILIO_APPROVED: "twilio-approved",
  PROVISIONALLY_APPROVED: "provisionally-approved",
};

export const addressDocumentTypes = [
  {
    label: "Excerpt from the commercial register showing the local address",
    value: "commercial_registrar_excerpt",
  },
  {
    label: "Business registration showing the local address",
    value: "business_registration",
  },
  { label: "Utility bill", value: "utility_bill" },
  { label: "Tax notice", value: "tax_document" },
  { label: "Rent receipt", value: "rental_receipt" },
  { label: "Title deed", value: "title_deed" },
];

export const nameDocumentTypes = [
  {
    label: "Excerpt from the commercial register",
    value: "commercial_registrar_excerpt",
  },
  { label: "Business registration", value: "business_registration" },
];

export const countryDocumentConfig = {
  [countryMapping.NZ]: {
    showBothSections: true,
    addressDocumentTypes: addressDocumentTypes,
    nameDocumentTypes: nameDocumentTypes,
    apiPayloadType: "separate_files",
    sectionTitle: "Business Address (Proof of Address)",
  },
  [countryMapping.CH]: {
    showBothSections: false,
    addressDocumentTypes: [
      {
        label: "Excerpt from the commercial register showing the local address",
        value: "commercial_registrar_excerpt",
      },
    ],
    nameDocumentTypes: [],
    apiPayloadType: "single_file",
    sectionTitle: "Business Registration Document",
  },

  default: {
    showBothSections: true,
    addressDocumentTypes: addressDocumentTypes,
    nameDocumentTypes: nameDocumentTypes,
    apiPayloadType: "separate_files",
    sectionTitle: "Business Address (Proof of Address)",
  },
};

export const getCountryDocumentConfig = (countryCode) => {
  return countryDocumentConfig[countryCode] || countryDocumentConfig.default;
};

export const stepsByCountry = {
  [countryMapping.NZ]: [
    { label: "Business Address", component: BusinessAddress },
    { label: "Supporting Documents", component: SupportingDocuments },
  ],
  [countryMapping.CH]: [
    { label: "Business Address", component: BusinessAddress },
    { label: "Supporting Documents", component: SupportingDocuments },
  ],
  [countryMapping.UK]: [
    { label: "Business Information", component: BusinessInformation },
    { label: "Business Address", component: BusinessAddress },
    { label: "Contact Details", component: ContactDetails },
  ],
};

export const stepLabels = {
  [registrationSubmissionStatus.BUSINESS_INFORMATION]: "Business Information",
  [registrationSubmissionStatus.BUSINESS_ADDRESS]: "Business Address",
  [registrationSubmissionStatus.CONTACT_DETAILS]: "Contact Details",
  [registrationSubmissionStatus.SUPPORTING_DOCUMENTS]: "Supporting Documents",
};

export const numberVerificationErrors = {
  EXPIRED: "expired",
  MAX_RETRIES: "max_retries",
  INVALID: "invalid",
};

export const numberVerificationErrorStatement = {
  [numberVerificationErrors.EXPIRED]: "OTP has expired, resend again!",
  [numberVerificationErrors.MAX_RETRIES]:
    "You have exceeded the maximum retries to retrieve!",
  [numberVerificationErrors.INVALID]:
    "Invalid OTP! Please enter the correct OTP",
};

export const emergencyNumbers = {
  US: ["911", "0911"],
  UK: ["999", "112", "101", "116000", "116123"],
  NZ: ["111", "105", "0800842846"],
  CH: ["112", "117", "118", "144"],
  IN: [
    "100",
    "101",
    "102",
    "108",
    "112",
    "103",
    "104",
    "105",
    "106",
    "107",
    "109",
    "110",
    "181",
    "197",
    "1073",
    "1075",
    "1077",
    "1090",
    "1091",
    "1094",
    "1095",
    "1098",
    "1291",
    "1363",
    "1962",
    "14416",
  ],
  INTERNATIONAL: [
    "113",
    "114",
    "115",
    "116",
    "117",
    "118",
    "119",
    "122",
    "123",
    "125",
  ],
};

export const allEmergencyNumbers = [
  ...emergencyNumbers.US,
  ...emergencyNumbers.UK,
  ...emergencyNumbers.NZ,
  ...emergencyNumbers.CH,
  ...emergencyNumbers.IN,
  ...emergencyNumbers.INTERNATIONAL,
];

export const addCallerIDSteps = {
  ADD_DETAILS: "add_details",
  VERIFICATION: "verification",
};

export const addCallerIDStatuses = {
  FAILED: "failed",
  PENDING: "pending",
  SUCCESS: "success",
};

export const addCallerIDStates = {
  EXISTING: "existing",
  PENDING: "pending",
  NEW: "new",
};
